// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/Main-image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App_AppDesktop__pCvKU {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: row;
}

.App_tabs__-rQ04 {
  position: relative;
  z-index: 100;
}

.App_tabsDesktop__cx1N0 {
  display: flex;
  flex-direction: row;
}

.App_tabsTablet__AzEVa {
  display: none;
}

.App_fixedTabs__nRhgG {
  width: 100vw;
  display: flex;
  flex-direction: column;
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  position: fixed;
  bottom: 0;
}
.App_fixedTabs__nRhgG > div {
  padding: 16px 37px 16px 24px;
}
.App_fixedTabs__nRhgG .App_imageSE__It7xG {
  padding: 0;
  height: 40vh;
  background-position: right -25px bottom 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 33vh;
}
.App_fixedTabs__nRhgG .App_imageProMax__E\\+n4w {
  padding: 0;
  height: 50vh;
  background-position: right -33px bottom 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 33vh;
}
.App_fixedTabs__nRhgG .App_a__pvP5B {
  background-color: #0085FF;
}
.App_fixedTabs__nRhgG .App_b__z2xmh {
  background-color: #69B4FF;
}
.App_fixedTabs__nRhgG .App_n__SBlVO {
  background-color: #E0FFFF;
}
.App_fixedTabs__nRhgG .App_c__9aFOW {
  background-color: #70E072;
}

.App_copyright__V8scU {
  position: absolute;
  bottom: 22px;
  left: 22px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 150%;
  color: #140C0F;
}

.App_fixed__epbH6 {
  position: fixed;
  bottom: 0;
  background-color: red;
  left: 50%;
}

.App_fixed__epbH6 {
  position: fixed;
  bottom: 0;
  background-color: red;
  left: 50%;
}`, "",{"version":3,"sources":["webpack://./src/App/App.module.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,YAAA;EAEA,aAAA;EACA,sBAAA;EC8EA,kCAjEkB;EAkElB,eAzDa;EA0Db,iBAjDe;EAkDf,cAxGgB;EAyGhB,gBAlEW;EDdX,eAAA;EACA,SAAA;AAAF;AAGE;EACE,4BAAA;AADJ;AAIE;EACE,UAAA;EACA,YAAA;EACA,yCAAA;EACA,yDAAA;EACA,4BAAA;EACA,qBAAA;AAFJ;AAME;EACE,UAAA;EACA,YAAA;EACA,yCAAA;EACA,yDAAA;EACA,4BAAA;EACA,qBAAA;AAJJ;AAOE;EACE,yBCjDM;AD4CV;AASE;EACE,yBCrDO;AD8CX;AAWE;EACE,yBCzDG;ADgDP;AAaE;EACE,yBC7DM;ADkDV;;AAgBA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;ECIA,gCA7CiB;EA8CjB,eAtCa;EAuCb,iBA7Be;EA8Bf,cAnFgB;ADmElB;;AAaA;EACE,eAAA;EACA,SAAA;EACA,qBAAA;EACA,SAAA;AAVF;;AAaA;EACE,eAAA;EACA,SAAA;EACA,qBAAA;EACA,SAAA;AAVF","sourcesContent":["@import \"src/styles/variables\";\n\n.appTablet {}\n\n.AppDesktop {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  flex-direction: row;\n}\n\n.tabs {\n  position: relative;\n  z-index: 100;\n}\n\n.tabsDesktop {\n  display: flex;\n  flex-direction: row;\n}\n\n.tabsTablet {\n  display: none;\n}\n\n.fixedTabs {\n  width: 100vw;\n  //height: 45px;\n  display: flex;\n  flex-direction: column;\n  @include font-20-title;\n  position: fixed;\n  bottom: 0;\n\n\n  & > div {\n    padding: 16px 37px 16px 24px;\n  }\n\n  .imageSE {\n    padding: 0;\n    height: 40vh;\n    background-position: right -25px bottom 0;\n    background-image: url(\"../assets/images/Main-image.png\");\n    background-repeat: no-repeat;\n    background-size: 33vh;\n    //margin-right: -23px;\n  }\n\n  .imageProMax {\n    padding: 0;\n    height: 50vh;\n    background-position: right -33px bottom 0;\n    background-image: url(\"../assets/images/Main-image.png\");\n    background-repeat: no-repeat;\n    background-size: 33vh;\n  }\n\n  .a {\n    background-color: $aboutUs;\n    //background-color: red;\n  }\n\n  .b {\n    background-color: $Business;\n\n  }\n\n  .n {\n    background-color: $News;\n\n  }\n\n  .c {\n    background-color: $Contact;\n  }\n\n}\n\n.copyright {\n  position: absolute;\n  bottom: 22px;\n  left: 22px;\n  @include font-16;\n}\n\n.fixed {\n  position: fixed;\n  bottom: 0;\n  background-color: red;\n  left: 50%;\n}\n\n.fixed {\n  position: fixed;\n  bottom: 0;\n  background-color: red;\n  left: 50%;\n}","//tab sizes\n$tab-width: 60px;\n$not-active-tabs-width: 180px;\n\n//fonts colors\n$title-color: #191114;\n$sub-title-color: #140C0F;\n$footer-color: #323433;\n\n//tabs colors\n$aboutUs: #0085FF;\n$Business: #69B4FF;\n$News: #E0FFFF;\n$Contact: #70E072;\n$MessageSent: #A5F2A6;\n\n//def padding\n$mobile-tab-tablet-padding: 112px 24px 30px 24px;\n\n//def tab content styles\n@mixin selectedTablet {\n  cursor: default;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n@mixin closeIcon {\n  position: fixed;\n  right: 30px;\n  top: 28px;\n  z-index: 2;\n}\n\n//transitions\n$tab-transition: width .5s ease-in-out;\n$left-content-transition-1: opacity .7s ease-in-out;\n$left-content-transition-2: opacity 3s ease-in-out;\n\n//fonts values\n$font-family-main: 'Inter', sans-serif;\n$font-family-title: 'Poppins', sans-serif;\n\n$font-w-400: 400;\n$font-w-700: 700;\n\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-16: 16px; //150%\n$font-size-18: 18px; //150%\n$font-size-20: 20px; // 150%\n$font-size-22: 22px;\n$font-size-24: 24px; //150%\n$font-size-32: 32px; //100%\n$font-size-48: 48px; //80%\n\n$font-size-179: 179px; //80%\n\n$font-line-150p: 150%;\n$font-line-100p: 100%;\n$font-line-80p: 80%;\n\n//font variants\n@mixin font-title-179 {\n  font-family: $font-family-title;\n  font-size: $font-size-179;\n  line-height: $font-line-80p;\n  font-weight: $font-w-700;\n}\n\n@mixin font-13 {\n  font-family: $font-family-main;\n  font-size: $font-size-13;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-14 {\n  font-family: $font-family-main;\n  font-size: $font-size-14;\n  line-height: 16px;\n  color: $sub-title-color;\n}\n\n@mixin font-16 {\n  font-family: $font-family-main;\n  font-size: $font-size-16;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-18 {\n  font-family: $font-family-main;\n  font-size: $font-size-18;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20 {\n  font-family: $font-family-main;\n  font-size: $font-size-20;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20-title {\n  font-family: $font-family-title;\n  font-size: $font-size-20;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-22 {\n  font-family: $font-family-title;\n  font-size: $font-size-22;\n  line-height: $font-line-80p;\n  color: $sub-title-color;\n}\n\n@mixin font-24 {\n  font-family: $font-family-main;\n  font-size: $font-size-24;\n  line-height: $font-line-150p;\n  color: $title-color;\n  font-weight: $font-w-400;\n}\n\n@mixin font-24-bold {\n  @include font-24;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-32 {\n  font-family: $font-family-title;\n  font-size: $font-size-32;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-48 {\n  font-family: $font-family-title;\n  font-size: $font-size-48;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AppDesktop": `App_AppDesktop__pCvKU`,
	"tabs": `App_tabs__-rQ04`,
	"tabsDesktop": `App_tabsDesktop__cx1N0`,
	"tabsTablet": `App_tabsTablet__AzEVa`,
	"fixedTabs": `App_fixedTabs__nRhgG`,
	"imageSE": `App_imageSE__It7xG`,
	"imageProMax": `App_imageProMax__E+n4w`,
	"a": `App_a__pvP5B`,
	"b": `App_b__z2xmh`,
	"n": `App_n__SBlVO`,
	"c": `App_c__9aFOW`,
	"copyright": `App_copyright__V8scU`,
	"fixed": `App_fixed__epbH6`
};
export default ___CSS_LOADER_EXPORT___;
